
import { shiftSwapApi } from '@/api';
import { PropType } from 'vue';
import { ShiftSwap } from '../../../api/v1';
import ActionDialog from '../../components/dialog/ActionDialog.vue';
import { Icon } from '../../lib/enum/Icon';

export default {
  name: 'ShiftSwapCancellationDialog',

  components: {
    ActionDialog,
  },

  props: {
    shiftSwap: {
      type: Object as PropType<ShiftSwap>,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      Icon,
    };
  },
  computed: {
    open: {
      get() {
        return !!this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  methods: {
    cancel() {
      this.open = false;
    },
    confirm() {
      shiftSwapApi
        .cancelShiftSwap({
          id: this.shiftSwap.id,
        })
        .then(() => {
          this.open = false;
        });
    },
  },
};
